import {
    CREATE_QUARTERLY_TAX_RETURNS_ANNUAL_SUMMARY,
    INVALIDATE_QUARTERLY_TAX_RETURNS_ANNUAL_SUMMARY,
    RECEIVE_QUARTERLY_TAX_RETURNS_ANNUAL_SUMMARY,
    RECEIVE_QUARTERLY_TAX_RETURNS_ANNUAL_SUMMARY_PAYMENT_INVOICE,
    RECEIVE_QUARTERLY_TAX_RETURNS_ANNUAL_SUMMARY_PAYMENTS,
    REQUEST_QUARTERLY_TAX_RETURNS_ANNUAL_SUMMARY,
} from '../actions'
import { updateOrAddItemById } from '../helpers'

export default (
    state = {
        fetchSuccessful: null,
        isCreating: null,
        shouldFetch: true,
    },
    action
) => {
    const { type, data } = action

    switch (type) {
        case CREATE_QUARTERLY_TAX_RETURNS_ANNUAL_SUMMARY:
            return { ...state, isCreating: true }

        case REQUEST_QUARTERLY_TAX_RETURNS_ANNUAL_SUMMARY:
            return { ...state, shouldFetch: false }

        case RECEIVE_QUARTERLY_TAX_RETURNS_ANNUAL_SUMMARY:
            return { ...state, ...data }

        case RECEIVE_QUARTERLY_TAX_RETURNS_ANNUAL_SUMMARY_PAYMENTS:
            return { ...state, ...data }

        case RECEIVE_QUARTERLY_TAX_RETURNS_ANNUAL_SUMMARY_PAYMENT_INVOICE: {
            const { payments } = state

            const { paymentId: id, invoiceDownloadUrl } = data

            return { ...state, payments: updateOrAddItemById(payments, { id, invoiceDownloadUrl }) }
        }

        case INVALIDATE_QUARTERLY_TAX_RETURNS_ANNUAL_SUMMARY:
            return { ...state, shouldFetch: true }

        default:
            return state
    }
}
